import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BaseUrl = process.env.REACT_APP_BASEURL_SERVER;

export const ProductAPI = createApi({
    reducerPath: "ProductAPI",
    baseQuery: fetchBaseQuery({
        baseUrl: BaseUrl,
        prepareHeaders: (headers, { endpoint }) => {
            const token = localStorage.getItem("accessToken");
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }

            headers.set("Accept", "application/json");
            if (!["addProduct", "updateProduct", "updateProductStatus"].includes(endpoint)) {
                headers.set("Content-Type", "application/json");
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        addProduct: builder.mutation({
            query: (formData) => ({
                url: "admin/products",
                method: "POST",
                body: formData,
            }),
        }),

        updateProduct: builder.mutation({
            query: ({ formData, id }) => ({
                url: `admin/products/update-product/${id}`,
                method: "POST",
                body: formData,
            }),
        }),

        getProductList: builder.query({
            query: () => `admin/products`,
        }),

        getProductById: builder.query({
            query: (id) => `admin/products/show/${id}`,
        }),

        deleteProduct: builder.mutation({
            query: (id) => ({
                url: `admin/products/delete/${id}`,
                method: "DELETE",
            }),
        }),
        updateProductStatus: builder.mutation({
            query: (formData) => ({
                url: "admin/products/update-status",
                method: "POST",
                body: formData,
            }),
        }),
        StoreVarients: builder.mutation({
            query: (formData) => ({
                url: "admin/variants",
                method: "POST",
                body: formData,
            }),
        }),
        ListVarients: builder.query({
            query: () => `variants`,
        }),

        deleteVarient: builder.mutation({
            query: (id) => ({
                url: `admin/variants/${id}`,
                method: "DELETE",
            }),
        }),
        editVarient: builder.mutation({
            query: ({ formData, id }) => ({
                url: `admin/variants/${id}`,
                method: "POST",
                body: formData,
            }),
        }),
        getVarientById: builder.query({
            query: (id) => `variants/${id}`,
        }),
        deleteVariantbyProduct: builder.mutation({
            query: (formData) => ({
                url: `admin/products/delete-assign-variants`,
                method: "DELETE",
                body:formData
            }),
        }),

    }),
});

export const { useAddProductMutation, useDeleteProductMutation, useGetProductByIdQuery, useGetProductListQuery, useUpdateProductMutation, useUpdateProductStatusMutation, useStoreVarientsMutation, useListVarientsQuery , useDeleteVarientMutation, useEditVarientMutation, useGetVarientByIdQuery, useDeleteVariantbyProductMutation} = ProductAPI;
